import {
  DatagridConfigurable,
  FunctionField,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextField,
} from 'react-admin';
import { AIPromptsCommandPanel } from './AIPromptsCommandPanel';
import { Chip } from '@mui/material';
// import { outputTypes, outputTypesChoices } from "./AIPromptsEdit";

export const entityTypes = {
  journalEntries: 'Patient - Journal Entries',
  therapistSessionNotes: 'Therapist - Session Notes',
  therapistLiveNotes: 'Therapist - Live Notes',
  therapistHomework: 'Therapist - Homework',
};

const subTypes = {
  general: 'General',
  soap: 'SOAP',
};

export const entityTypesChoices = Object.entries(entityTypes).map(
  ([id, name]) => ({
    id,
    name,
  }),
);

export const frameworks = {
  all: 'General',
  soap: 'SOAP',
};

export const outputTypes = [
  'grammar',
  'bullet',
  'singleSentence',
  'tags',
  'title',
  'quickFacts',
] as const;

export const outputTypesChoices = outputTypes.map(id => ({
  id,
  name: id,
}));

const filters = [
  <SelectInput
    alwaysOn
    key="entityType"
    label="Entity Type"
    source="entityType"
    choices={entityTypesChoices}
  />,
  <SelectInput
    alwaysOn
    key="outputType"
    label="Output Type"
    source="outputType"
    choices={outputTypesChoices}
  />,
  <ReferenceInput
    key="subType"
    label="Framework"
    source="subType"
    reference="therapistSessionNotesFrameworks"
  >
    <SelectInput label="Framework" optionText="name" />
  </ReferenceInput>,
];

export const AIPromptsList = () => (
  <List
    resource="aiPrompts"
    filters={filters}
    sort={{ field: 'entityName', order: 'ASC' }}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      expand={AIPromptsCommandPanel}
    >
      <TextField source="id" />
      <FunctionField
        label="Entity Type"
        source="entityType"
        render={(el: any) => (entityTypes as any)[el.entityType]}
      />
      <FunctionField
        label="Output Type"
        source="outputType"
        render={(el: any) => <Chip label={el.outputType} />}
      />
      <FunctionField
        label="Framework"
        source="subType"
        render={(el: any) => (
          <ReferenceField
            record={el}
            source="subType"
            reference="therapistSessionNotesFrameworks"
          >
            <FunctionField
              render={(ref: any) => (
                <Chip label={ref?.name || 'General'} />
              )}
            />
          </ReferenceField>
        )}
      />
    </DatagridConfigurable>
  </List>
);
